export default "__VITE_ASSET__f8df3d15__"